import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { Card, Row, Col, Modal, Button, Form, Spinner, InputGroup, FormLabel, CloseButton } from 'react-bootstrap';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/es';
import { getCoreRowModel } from '@tanstack/react-table';
import { getExpandedRowModel } from '@tanstack/react-table';
import { useReactTable } from '@tanstack/react-table';
import { flexRender } from '@tanstack/react-table';
import { getPaginationRowModel } from '@tanstack/react-table';
import { getFilteredRowModel } from '@tanstack/react-table';
import { GoogleMapsProvider } from '../../../../providers/GoogleMapsProvider';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaFileExport, FaMapMarkerAlt } from 'react-icons/fa';
import GoogleMapSelector from '../../../../components/common/google-maps-selector/GoogleMapSelector';
import IconButton from '../../../../components/common/IconButton';
//import GoogleMapRoutes from '../../../../components/common/google-maps-advance/GoogleMapsRoutes';
import iconoPng from '../../../../assets/img/icons/export.png';
import './table-km.css';
import * as XLSX from 'xlsx';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReporteRecorridoService } from '../../../../services/apiService';
import Flex from '../../../../components/common/Flex';
import { QURO_MAP_CONFIG } from '../../../../config/apiConfig';
import { generateExcelReport } from '../../../../helpers/createExcelReport';
import { obtenerLinkMapa } from '../../../../helpers/utils';
import axios from 'axios';

// Activamos el soporte para formatos personalizados
dayjs.extend(customParseFormat);
dayjs.locale('es');

//Formatea la fecha obtenida por el servidor 
const formatFecha = (fechaStr) => {

    if (!fechaStr || typeof fechaStr !== 'string') return ' ';

    try {
        return dayjs(fechaStr, 'YYYY/MM/DD').format('DD/MM/YYYY');

    } catch (error) {

        console.error('Error al formatear la fecha:', error);
        return 'N/A';
    }
};

const ReportTableKM = ({ data = [], perPage = 10, title, isGroup, searchValue = '', onSearch, filtrosLocal }) => {

    //Valida el listado de informacion
    const safeTableData = Array.isArray(data) ? data : [];

    // Estado para manejar el modal del mapa
    const [globalFilter, setGlobalFilter] = useState(searchValue);
    const [inputValue, setInputValue] = useState(searchValue);
    const debounceTimeout = useRef(null);
    const [expanded, setExpanded] = useState(false);
    const [showMapModal, setShowMapModal] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState({ lat: null, lng: null });
    const [selectedLocations, setSelectedLocations] = useState([]);

    const [tokenQuro, setTokenQuro] = useState('');
    const [fechaInicial, setFechaInicial] = useState(Date.now());
    const [fechaFinal, setFechaFinal] = useState(Date.now());
    const [idVehiculo, setIdVehiculo] = useState(0);
    const [uidVehiculo, setUidVehiculo] = useState('');
    const [mapLoading, setMapLoading] = useState(false);



    const obtenerTokenQuro = async () => {

        const response = await ReporteRecorridoService.getTokenConexionQuro()
        if (response && response.statusCode === 200) {

            if (response.data != null && response.data.length != 0) {
                setTokenQuro(response.data)
            } else {

                setTokenQuro('')
            }

        }
    }

    const handleClickAbrirRecorrido = () => {

        obtenerTokenQuro()
    }

    useEffect(() => {

        if (tokenQuro.length > 0) {

            const _fechaCargaInicial = dayjs(fechaInicial).format('YYYY-MM-DDTHH:mm:ss')
            const _fechaUltimaCarga = dayjs(fechaFinal).format('YYYY-MM-DDTHH:mm:ss')

            const _redirect = `Uid=${uidVehiculo}&fecha_carga_inicia=${_fechaCargaInicial}&Fecha_Ultima_Carga=${_fechaUltimaCarga}`

            const mapUrl = obtenerLinkMapa(_redirect, QURO_MAP_CONFIG.BASE_URL);

            if (mapUrl) {
                window.open(mapUrl);
            }
        }
    }, [tokenQuro])

    //Funcion para administrar la paginacion de la tabla
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: perPage,
    });

    // Manejar el cambio en la búsqueda del filtro global de la tabla
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }
        debounceTimeout.current = setTimeout(() => {
            setGlobalFilter(value);
            if (onSearch) onSearch(value);
            setPagination(prev => ({ ...prev, pageIndex: 0 }));
        }, 400);
    };

    // Función para abrir el modal con la latitud y longitud seleccionadas
    const handleShowMap = (points) => {
        setSelectedLocation(points[0]);
        setSelectedLocations(points);
        setShowMapModal(true);
    };

    const style1Lines = {
        display: "-webkit-box",
        WebkitLineClamp: 1,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
    };
    const columns = [
        {
            header: ' ',
            cell: ({ row }) => {
                return row.getCanExpand() ?
                    <IconButton
                        variant="falcon-default"
                        size="sm"
                        icon={row.getIsExpanded() ? "chevron-up" : "chevron-down"}
                        transform="shrink-3"
                        onClick={row.getToggleExpandedHandler()}
                    />
                    : '';
            },
        },
        {
            accessorKey: 'noEconomico',
            header: 'Vehículo',
            meta: { headerProps: { className: 'text-900' } },
            cell: ({ row: { original }, row }) => {
                const noEconomico = original.noEconomico || '';
                const aliasVehiculo = original.aliasVehiculo || original.alias || '';

                let display = '';
                if (noEconomico && aliasVehiculo) {
                    display = `${noEconomico} / ${aliasVehiculo}`;
                } else {
                    display = noEconomico || aliasVehiculo || 'N/A';
                }

                const isCollapsable = row.getCanExpand();

                return (
                    <Row>
                        <Col className={isCollapsable ? "fw-bold" : ""}>
                            <span style={style1Lines} title={display}>{display}</span>
                        </Col>
                    </Row>
                );
            },
        },
        /*{
            accessorKey: 'fechaCorta',
            header: '',
            meta: { headerProps: { className: 'text-900' } },
            cell: ({ row }) => {
                const isCollapsable = row.getCanExpand();
                const value = row.getCanExpand()
                    ? row.original.fechaCorta
                    : formatFecha(row.original.fechaCorta);

                return (
                    <Row>
                        <Col className={isCollapsable ? "fw-bold" : ""}>
                            <span title={value}>{value}</span>
                        </Col>
                    </Row>
                );
            },
        },*/
        {
            accessorKey: 'cliente',
            header: 'Dia',
            meta: { headerProps: { className: 'text-900' } },
            cell: ({ row: { original }, row }) => {
                const isCollapsable = row.getCanExpand();//(isCollapsable ? (row.original.fechaCorta || '') : '') + " " + s
                const value = original.cliente || '';
                return (
                    <Row>
                        <Col className={isCollapsable ? "fw-bold" : ""}>
                            <span style={style1Lines} title={value}>{value}</span>
                        </Col>
                    </Row >
                );
            },
        },
        {
            accessorKey: 'promedio_distancia',
            header: 'Distancia',
            meta: { headerProps: { className: 'text-900' } },
            cell: ({ row: { original }, row }) => {
                const isCollapsable = row.getCanExpand();
                const distancia = original.promedio_distancia || 0;
                let value = '';
                if (typeof distancia === 'number') {
                    value = `${distancia.toFixed(2)} km`;
                } else {
                    const distanciaStr = distancia.toString();
                    value = distanciaStr.toLowerCase().includes('km') ? distanciaStr : `${distanciaStr} km`;
                }
                return (
                    <Row>
                        <Col className={isCollapsable ? "fw-bold" : ""}>
                            <span style={style1Lines} title={value}>{value}</span>
                        </Col>
                    </Row>
                );
            }
        },
        {
            accessorKey: "mapa",
            header: "Mapa",
            cell: ({ row: { original }, row }) => {
                const isCollapsable = row.getCanExpand();
                return (
                    <Row>
                        <Col className={isCollapsable ? "fw-bold text-center" : "text-center"}>
                            <a
                                href="#!"
                                variant='default'
                                onClick={async (e) => {
                                    e.preventDefault();
                                    setIdVehiculo(original.vehiculoId);
                                    setUidVehiculo(original.vehiculoUid);

                                    // Establecer fechas para botón "Abrir recorrido"
                                    if (original.children) {
                                        setFechaInicial(dayjs(original.children[0].fechaCorta + " 12:00 AM"));
                                        setFechaFinal(dayjs(original.children[original.children.length - 1].fechaCorta + " 11:59 PM"));
                                    } else {
                                        setFechaInicial(dayjs(original.fechaCorta + " 12:00 AM"));
                                        setFechaFinal(dayjs(original.fechaCorta + " 11:59 PM"));
                                    }

                                    // Si listPoints tiene datos, usarlos directo (compatibilidad)
                                    if (original.listPoints && original.listPoints.length > 0) {
                                        handleShowMap(
                                            original.listPoints.map(w => ({ "lat": parseFloat(w.latitud), "lng": parseFloat(w.longitud) }))
                                        );
                                    } else {
                                        // Carga lazy: obtener puntos GPS desde V4
                                        setShowMapModal(true);
                                        setMapLoading(true);
                                        setSelectedLocations([]);

                                        try {
                                            let fechaInicio, fechaFin;

                                            if (original.children && original.children.length > 0) {
                                                // Fila HEADER (agrupada por vehículo): usar rango de fechas de los children
                                                const primerDia = original.children[0].fechaCorta.replace(/\//g, '-');
                                                const ultimoDia = original.children[original.children.length - 1].fechaCorta.replace(/\//g, '-');
                                                fechaInicio = `${primerDia}T00:00:00`;
                                                fechaFin = `${ultimoDia}T23:59:59`;
                                            } else {
                                                // Fila individual (un día): usar fechaCorta directa
                                                const fechaDia = original.fechaCorta.replace(/\//g, '-');
                                                fechaInicio = `${fechaDia}T00:00:00`;
                                                fechaFin = `${fechaDia}T23:59:59`;
                                            }

                                            const response = await axios.post(
                                                process.env.REACT_APP_VEHICLE_LOCATIONS_V4_URL,
                                                {
                                                    uids_vehiculo: [original.vehiculoUid],
                                                    fecha_inicio: fechaInicio,
                                                    fecha_fin: fechaFin,
                                                    empresaUid: filtrosLocal?.empresaUid,
                                                    limit: 10000,
                                                    count: true
                                                },
                                                { timeout: 120000 }
                                            );

                                            let allItems = response.data?.data?.items || [];

                                            // Si hay más páginas, iterar con cursor
                                            let nextCursor = response.data?.data?.pagination?.nextCursor;
                                            let hasMore = response.data?.data?.pagination?.hasMore;

                                            while (hasMore && nextCursor) {
                                                const nextResponse = await axios.post(
                                                    process.env.REACT_APP_VEHICLE_LOCATIONS_V4_URL,
                                                    {
                                                        uids_vehiculo: [original.vehiculoUid],
                                                        fecha_inicio: fechaInicio,
                                                        fecha_fin: fechaFin,
                                                        empresaUid: filtrosLocal?.empresaUid,
                                                        limit: 10000,
                                                        cursor: nextCursor
                                                    },
                                                    { timeout: 120000 }
                                                );
                                                allItems = [...allItems, ...(nextResponse.data?.data?.items || [])];
                                                nextCursor = nextResponse.data?.data?.pagination?.nextCursor;
                                                hasMore = nextResponse.data?.data?.pagination?.hasMore;
                                            }

                                            const points = allItems
                                                .map(p => ({ lat: parseFloat(p.latitud), lng: parseFloat(p.longitud), fecha: p.fecha }))
                                                .filter(p => !isNaN(p.lat) && !isNaN(p.lng) && p.lat !== 0 && p.lng !== 0)
                                                .sort((a, b) => new Date(a.fecha) - new Date(b.fecha));

                                            if (points.length > 0) {
                                                setSelectedLocation(points[0]);
                                                setSelectedLocations(points);
                                            }
                                        } catch (error) {
                                            console.error('Error cargando puntos GPS para mapa:', error);
                                        } finally {
                                            setMapLoading(false);
                                        }
                                    }
                                }}
                            >
                                <FaMapMarkerAlt className="text-danger" />
                            </a>
                        </Col>
                    </Row>
                );
            },
            meta: {
                headerProps: { className: "text-900 text-center" },
                cellProps: { className: "text-center" },
            },
        }
    ];

    // Función de filtro global personalizada
    const tableGlobalFilterFn = useCallback((row, columnId, filterValue) => {
        const original = row.original;

        // Construir una cadena con todo el contenido buscable de la fila
        const searchableRowContent = [
            original.noEconomico || '',
            original.aliasVehiculo || original.alias || '',
            original.cliente || '',
            original.fechaCorta || '',
            original.promedio_distancia || '',
            // Incluir también los datos de los hijos si existen
            ...(original.children || []).map(child => [
                child.noEconomico || '',
                child.aliasVehiculo || child.alias || '',
                child.cliente || '',
                child.fechaCorta || '',
                child.promedio_distancia || '',
                // Incluir también la fecha formateada de los hijos
                formatFecha(child.fecha || child.fechaCorta || '')
            ].join(' '))
        ]
            .filter(Boolean) // Eliminar valores nulos o undefined
            .join(' ')
            .toLowerCase();

        const matches = searchableRowContent.includes(String(filterValue).toLowerCase());

        return matches;
    }, []);

    const table = useReactTable({
        data: safeTableData, // Usar safeTableData directamente
        columns,
        sortable: true,
        pagination: true,
        perPage,
        state: {
            globalFilter,
            pagination,
        },
        onGlobalFilterChange: setGlobalFilter,
        onPaginationChange: setPagination,
        globalFilterFn: tableGlobalFilterFn,
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getSubRows: (row) => row.children,
        getExpandedRowModel: getExpandedRowModel(),
        enableGlobalFilter: true, // Habilitar el filtro global de la tabla
        debugTable: false,
        enableColumnFilters: false
    });

    //Pluigin XLSX para generar libre de excel
    const creandoArchivo = (dataFinal) => {
        if (window['guardarBitacoraExport']) {
            try {
                window['guardarBitacoraExport']();
            } catch (error) {

            }
        }
        const libro = XLSX.utils.book_new();

        const hoja = XLSX.utils.json_to_sheet(dataFinal, { skipHeader: true });

        const _totalFilas = dataFinal.length + 1
        const longitudes = [];

        hoja["!merges"] = [
            XLSX.utils.decode_range("A1:E1"),
            XLSX.utils.decode_range("A2:E2"),
            //XLSX.utils.decode_range(`A${_totalFilas}:E${_totalFilas}`),
        ];

        let propiedades = [];

        longitudes.forEach((col) => {
            propiedades.push({
                width: col,
            });
        });

        hoja["!cols"] = propiedades;

        XLSX.utils.book_append_sheet(libro, hoja, "Eventos");

        XLSX.writeFile(libro, "ReporteKM.xlsx");
    };

    //Funcion para formatear la data de un documento en formato excel 
    const exportarDatos = () => {

        const titulo = [{ A: 'Reporte de Kilometros' }, {}]

        let tabla = [
            {
                A: 'Vehiculo',
                B: 'Dia',
                C: 'Distancia (KM)',
            }
        ]

        safeTableData.forEach((i) => {

            if (i.children) {

                i.children.forEach((sub) => {

                    tabla.push({
                        A: sub.noEconomico || '',
                        B: sub.cliente || '',
                        C: sub.promedio_distancia || '0'
                    })
                })

            }

        })

        const dataFinal = [...titulo, ...tabla]

        setTimeout(() => {
            creandoArchivo(dataFinal);
        }, 1000);
    }

    //Evento para exportar a excel
    const handleExportar = () => {
        try {
            if (window['guardarBitacoraExport']) {
                try {
                    window['guardarBitacoraExport']();
                } catch (error) {

                }
            }

            //Columnas del reporte 
            let columns = [
                'Vehiculo',
                'Dia',
                'Distancia',
            ]
            debugger;
            // Agregar maestro-detalle 
            let dataReport = [];

            safeTableData.forEach((grupo, index) => {

                //Detallado por vehiculo 
                let subList = [];

                // Filas de detalles
                grupo.children.forEach(detalle => {

                    subList.push([
                        (detalle.noEconomico?.toString() || "N/A") + ' / ' + (detalle.aliasVehiculo?.toString() || "N/A"),
                        detalle.cliente?.toString() || "N/A",
                        `${detalle.promedio_distancia} km` || "N/A",
                    ]);
                });

                const vehicleName = (grupo.noEconomico?.toString() || "N/A") + ' / ' + (grupo.aliasVehiculo?.toString() || "N/A")

                //maestro
                let masterData =
                {
                    titulo: `Vehiculo: (${vehicleName})  |  ${grupo.cliente} | ${grupo.promedio_distancia} | ${grupo.fechaCorta}`,
                    detalles: subList
                }

                //Agrega el maestro a la lista de informacion
                dataReport.push(masterData);
            });

            //Exportar reporte 
            generateExcelReport('Reporte Kilometros', dataReport, true, columns);

        } catch (error) {
            console.error("Error al exportar a Excel:", error);
        }
    }

    return (
        <Card className='h-100 mt-3'>

            <Card.Header>
                <Row className="d-flex align-items-center justify-content-between">
                    <Col md={6}>
                        <h6 className="mb-0 text-nowrap py-2 py-xl-0">{title}</h6>
                    </Col>

                    <Col md={4} className="d-flex justify-content-end align-items-center">
                        <Button
                            variant="primary"
                            size="sm"
                            className="me-2 p-2"
                            onClick={(e) => {
                                e.preventDefault();
                                handleExportar();
                            }}
                        >
                            <img
                                src={iconoPng}
                                alt="Exportar" title='Exportar a Excel'
                                style={{ width: '20px', height: '20px', filter: 'brightness(0) invert(1)' }} // Ajusta el tamaño
                                className="me-1 ms-1"
                            />
                            {/* <FaFileExport className="me-1 ms-1" /> */}
                        </Button>

                        <InputGroup size="sm" style={{ maxWidth: 200 }}>

                            <Form.Control
                                className='p-2'
                                type="text"
                                placeholder="Buscar..."
                                value={inputValue || ''}
                                onChange={handleSearchChange}
                            />
                            {globalFilter && (
                                <Button
                                    variant="outline-secondary"
                                    onClick={() => {
                                        setGlobalFilter('');
                                        if (onSearch) onSearch('');
                                    }}
                                >
                                    &times;
                                </Button>
                            )}

                        </InputGroup>
                    </Col>
                    <Col md={2}>

                        <Form className='d-flex p-2 justify-content-end'>
                            <Form.Select
                                className='p-2'
                                size="sm"
                                style={{ width: '100px' }}
                                value={table.getState().pagination.pageSize}
                                onChange={e => table.setPageSize(Number(e.target.value))}
                            >
                                {[10, 50, 100, 500, 1000].map(pageSize => (
                                    <option key={pageSize} value={pageSize}>
                                        {pageSize}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form>
                    </Col>
                </Row>
            </Card.Header>

            <Card.Body className='mt-0 pt-0 pe-0 ps-0'>
                <GoogleMapsProvider>
                    <table className='fs-10 mb-0 overflow-hidden table table-striped'>
                        <thead className='text-nowrap align-middle'>
                            {table.getHeaderGroups().map(headerGroup => (
                                <tr key={headerGroup.id}>
                                    {headerGroup.headers.map(header => {
                                        return (
                                            <th key={header.id} colSpan={header.colSpan} className="fw-bold">
                                                {header.isPlaceholder ? null : (
                                                    <div>
                                                        {flexRender(
                                                            header.column.columnDef.header,
                                                            header.getContext()
                                                        )}

                                                        {header.column.getCanFilter() ? (
                                                            <div>
                                                                <Filter column={header.column} table={table} />
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                )}
                                            </th>
                                        )
                                    })}
                                </tr>
                            ))}
                        </thead>
                        <tbody>
                            {table.getRowModel().rows.map(row => {
                                return (
                                    <tr key={row.id}>
                                        {row.getVisibleCells().map(cell => {
                                            return (
                                                <td key={cell.id}>
                                                    {flexRender(
                                                        cell.column.columnDef.cell,
                                                        cell.getContext()
                                                    )}
                                                </td>
                                            )
                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>

                    {/* Modal para ver el mapa */}
                    <Modal
                        show={showMapModal}
                        onHide={() => setShowMapModal(false)}
                        size="lg"
                        centered

                    >
                        <Modal.Header className="d-flex justify-content-between align-items-center" >
                            <Modal.Title className="mb-0">
                                Recorrido
                            </Modal.Title>

                            <div className='d-flex align-items-center gap-2'>
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    style={{
                                        backgroundColor: 'white',
                                        color: '#2c7be5'
                                    }}
                                    onClick={handleClickAbrirRecorrido}
                                >
                                    <FontAwesomeIcon icon={faExternalLinkAlt} /> Abrir recorrido
                                </Button>
                                <CloseButton onClick={() => setShowMapModal(false)} />
                            </div>

                        </Modal.Header>
                        <Modal.Body>
                            {mapLoading ? (
                                <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '400px' }}>
                                    <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
                                    <span className="mt-3 text-muted">Cargando ruta del vehículo...</span>
                                </div>
                            ) : (Array.isArray(selectedLocations) ? selectedLocations : []).length > 0 ? (
                                <GoogleMapSelector
                                    initialCenter={selectedLocation}
                                    markers={selectedLocations}
                                    waypoints={selectedLocations}
                                    zoomDefault={13}
                                    mapStyle="Default"
                                    className="vh-50"
                                    showStreetView={false}
                                />
                            ) : (
                                <div>
                                    <p>Ubicación no disponible</p>
                                </div>
                            )}
                        </Modal.Body>
                    </Modal>
                </GoogleMapsProvider>
            </Card.Body>

            <Card.Footer className="bg-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div className="d-flex align-items-center">
                        <span className="me-2">
                            Total: {table.getFilteredRowModel().rows.length} | Página {table.getState().pagination.pageIndex + 1} de {table.getPageCount()}
                        </span>
                        <Form.Control
                            type="number"
                            min="1"
                            max={table.getPageCount()}
                            value={table.getState().pagination.pageIndex + 1}
                            onChange={e => {
                                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                table.setPageIndex(page);
                            }}
                            style={{ width: '70px', height: '31px' }}
                            size="sm"
                        />
                    </div>

                    <div className="d-flex justify-content-center">

                        <Button
                            variant="outline-dark"
                            size="sm"
                            className="mx-1"
                            onClick={() => table.setPageIndex(0)}
                            disabled={!table.getCanPreviousPage()}
                        >
                            <FaAngleDoubleLeft />
                        </Button>

                        <Button
                            variant="outline-dark"
                            size="sm"
                            className="mx-1"
                            onClick={() => table.previousPage()}
                            disabled={!table.getCanPreviousPage()}
                        >
                            <FaAngleLeft />
                        </Button>

                        {/* Mostrar números de página (5 páginas alrededor de la actual) */}
                        {(() => {
                            // Determinar qué páginas mostrar
                            let pagesArray = [];
                            if (table.getPageCount() <= 5) {
                                // Si hay 5 o menos páginas, mostrarlas todas
                                pagesArray = Array.from({ length: table.getPageCount() }, (_, i) => i);
                            } else if (table.getState().pagination.pageIndex <= 2) {
                                // Si estamos en las primeras páginas
                                pagesArray = [0, 1, 2, 3, 4];
                            } else if (table.getState().pagination.pageIndex >= table.getPageCount() - 3) {
                                // Si estamos en las últimas páginas
                                pagesArray = [
                                    table.getPageCount() - 5,
                                    table.getPageCount() - 4,
                                    table.getPageCount() - 3,
                                    table.getPageCount() - 2,
                                    table.getPageCount() - 1
                                ];
                            } else {
                                // Estamos en medio, mostrar 2 antes y 2 después
                                pagesArray = [
                                    table.getState().pagination.pageIndex - 2,
                                    table.getState().pagination.pageIndex - 1,
                                    table.getState().pagination.pageIndex,
                                    table.getState().pagination.pageIndex + 1,
                                    table.getState().pagination.pageIndex + 2
                                ];
                            }

                            return pagesArray.map(pageNum => (
                                <Button
                                    key={`page-${pageNum}`}
                                    variant={pageNum === table.getState().pagination.pageIndex ? "primary" : "outline-dark"}
                                    size="sm"
                                    className="mx-1"
                                    onClick={() => table.setPageIndex(pageNum)}
                                >
                                    {pageNum + 1}
                                </Button>
                            ));
                        })()}

                        <Button
                            variant="outline-dark"
                            size="sm"
                            className="mx-1"
                            onClick={() => table.nextPage()}
                            disabled={!table.getCanNextPage()}
                        >
                            {/* Siguiente &gt; */}
                            <FaAngleRight />
                        </Button>

                        <Button
                            variant="outline-dark"
                            size="sm"
                            className="mx-1"
                            onClick={() => table.setPageIndex(table.getPageCount() - 1)}
                            disabled={!table.getCanNextPage()}
                        >
                            {/* Última &raquo; */}
                            <FaAngleDoubleRight />
                        </Button>
                    </div>

                    {/* <div>
                        <Form.Select
                            size="sm"
                            style={{ width: '120px' }}
                            value={table.getState().pagination.pageSize}
                            onChange={e => table.setPageSize(Number(e.target.value))}
                        >
                            {[10, 20, 30, 40, 50].map(pageSize => (
                                <option key={pageSize} value={pageSize}>
                                    {pageSize} por pág.
                                </option>
                            ))}
                        </Form.Select>
                    </div> */}
                </div>
            </Card.Footer>

        </Card>
    )
}

export default ReportTableKM;